import { render, staticRenderFns } from "./Regimen.vue?vue&type=template&id=6d1f7097"
import script from "./Regimen.vue?vue&type=script&lang=js"
export * from "./Regimen.vue?vue&type=script&lang=js"
import style0 from "./Regimen.vue?vue&type=style&index=0&id=6d1f7097&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports